<template>
  <div class="m-live-bubble-ball-container">
    <div
      v-if="visible"
      class="m-live-bubble-ball-wrap"
    >
      <a
        class="m-live-bubble-ball"
        @click.prevent="onClick"
      >
        <img
          :src="bubble.image"
          :alt="bubble.text"
        >
      </a>
    </div>

    <VDialogBox
      v-model="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      class="dialog-push-ad"
    >
      <div class="m-detail-popup-ad-wrap">
        <div class="m-detail-popup-ad">
          <img :src="bubble.href">
        </div>

        <button
          class="m-pop-close-btn"
          @click="handleCloseDialog"
        >
          <svg-icon icon-class="icon-close-round" />
        </button>
      </div>
    </VDialogBox>
  </div>
</template>

<script>
// 浮窗广告
import { storeToRefs } from 'pinia'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import VDialogBox from 'fe-vui/dialogBox'
import { getAdInfo } from 'wap/common/api'
import modalHelper from '@ms/utils/scroll-fixed'
import 'base/icons/svg/close-round.svg'

export default {
  name: 'BubbleBall',
  components: {
    VDialogBox
  },
  setup() {
    const matchDetailStore = useMatchDetailStore()
    const { liveCommentaryHasVouvher } = storeToRefs(matchDetailStore)

    return {
      liveCommentaryHasVouvher
    }
  },
  data() {
    return {
      visible: false,
      height: 0,
      bubble: {},
      dialogVisible: false
    }
  },
  watch: {
    liveCommentaryHasVouvher(val) {
      if (val) this.initFetch()
    }
  },
  mounted() {
    if (this.liveCommentaryHasVouvher) this.initFetch()
  },
  methods: {
    renderImage() {
      const img = new Image()
      img.onload = () => {
        this.visible = true
        // 2x 图
        // this.height = img.height / 2
      }
      img.src = this.bubble.image
    },
    onClick() {
      this.dialogVisible = true
      modalHelper.afterOpen()
    },
    handleClose() {
      this.visible = false
    },
    initFetch() {
      getAdInfo(['CommentBottomBanner'])
        .then((data) => {
          const x = data[0]
          const adList = x.ads
          this.bubble = adList && adList[0]
          this.renderImage()
        })
        .catch(console.error)
    },
    handleCloseDialog() {
      modalHelper.beforeClose()
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.m-live-bubble-ball-wrap {
  width: 32px;
  // position: fixed;
  // left: 10px;
  // bottom: 80px;
  // z-index: 9;
  margin-right: 10/@rem;
  user-select: none;

  &.releft {
    transition: left 0.3s linear;
  }
}

.m-live-bubble-ball {
  display: block;
  width: 100%;

  img {
    display: block;
    width: 100%;
  }
}

.m-detail-popup-ad-wrap {
  position: relative;

  .m-pop-close-btn {
    position: absolute;
    bottom: -60px;
    left: 50%;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    transform: translateX(-50%);

    .svg-icon {
      color: #939393;
      font-size: 40px;
      line-height: 1;
    }
  }

  .m-detail-popup-ad {
    display: block;
    width: auto;

    img {
      max-width: 80vw;
      max-height: 70vh;
      vertical-align: top;
    }
  }
}

.dialog-push-ad {
  .dialog {
    width: initial;
    max-width: 100%;
    background: transparent;
  }
}

</style>
